<template>
    <div id="stockcount-tablet-page">
        <div class="col-33">
            <div class="box">
                <div class="box-title">
                    {{ trans('pages.stockcount_tablet.article') }}
                </div>

                <div class="box-row">
                    <div class="box-50">
                        {{ trans('pages.stockcount_tablet.article_number') }}
                    </div>
                    <div class="box-50">
                        <div class="profile-nr-field">
                            <i
                                class="fa fa-camera"
                                @click="scanProfile"
                            />
                            <ui5-input
                                type="Text"
                                id="stockcount-profile"
                                :value="profileCode"
                                @input="profileCode = $event.target.value"
                                @keyup.enter="showProfileTablet"
                                @blur="showProfileTablet"
                            />
                        </div>
                    </div>
                </div>

                <div class="box-row">
                    <div class="box-50">
                        {{ trans('pages.stockcount_tablet.code') }}
                    </div>
                    <div class="box-50">
                        <template v-if="profile">
                            {{ profile.code || '' }}
                        </template>
                    </div>
                </div>

                <div class="box-row">
                    <div class="box-50">
                        {{ trans('pages.stockcount_tablet.description') }}
                    </div>
                    <div class="box-50">
                        <template v-if="profile">
                            {{ profile.description || '' }}
                        </template>
                    </div>
                </div>

                <div class="box-row">
                    <div class="box-50">
                        {{
                            trans(
                                'pages.stockcount_tablet.supplier_article_number'
                            )
                        }}
                    </div>
                    <div class="box-50">
                        <template v-if="profile">
                            {{ profile.supplierCode || '' }}
                        </template>
                    </div>
                </div>

                <div class="box-row">
                    <div class="box-50">
                        {{ trans('pages.stockcount_tablet.supplier') }}
                    </div>
                    <div class="box-50">
                        <template v-if="profile">
                            {{ profile.supplierName || '' }}
                        </template>
                    </div>
                </div>

                <div class="box-row center">
                    <img
                        v-if="profile"
                        :src="profile.cloudFrontPath"
                    />
                </div>

                <div class="box-row">
                    <ui5-button
                        @click="
                            $router.push(
                                '/editprofilepage/' + profile.profileId
                            )
                        "
                        :disabled="!inputEnabled"
                    >
                        {{ trans('pages.stockcount_tablet.buttons.edit') }}
                    </ui5-button>
                </div>

                <div class="box-row">
                    <ui5-button
                        @click="printKanban"
                        :disabled="!inputEnabled"
                    >
                        {{
                            trans(
                                'pages.stockcount_tablet.buttons.print_kanban'
                            )
                        }}
                    </ui5-button>
                </div>

                <div class="box-row">
                    <ui5-button
                        @click="printLabel"
                        :disabled="!inputEnabled"
                    >
                        {{
                            trans('pages.stockcount_tablet.buttons.print_label')
                        }}
                    </ui5-button>
                </div>

                <div class="box-row">
                    <ui5-button
                        @click="scanLocation"
                        :disabled="!inputEnabled"
                    >
                        {{
                            trans(
                                'pages.stockcount_tablet.buttons.assign_location'
                            )
                        }}
                    </ui5-button>
                </div>
            </div>
        </div>

        <div class="col-67">
            <div class="box">
                <div class="box-title">
                    {{ trans('pages.stockcount_tablet.stock.title') }}
                </div>

                <div class="box-row">
                    <div class="box-25">
                        {{
                            trans('pages.stockcount_tablet.stock.current_stock')
                        }}
                    </div>
                    <div class="box-25">
                        <text-input
                            type="number"
                            :value="profile ? profile.currentstockcount : ''"
                            @input="profile.currentstockcount = $event"
                            :disabled="!inputEnabled"
                            @change="updateTablet"
                        />
                    </div>

                    <div class="box-25 pad">
                        {{
                            trans('pages.stockcount_tablet.stock.latest_count')
                        }}
                    </div>
                    <div
                        class="box-25"
                        v-if="profile"
                    >
                        <template v-if="profile.latestCount">
                            {{ getLatestCount() }}
                        </template>
                        <template v-else>
                            {{ trans('pages.stockcount_tablet.stock.never') }}
                        </template>
                    </div>
                </div>

                <div class="box-row">
                    <div class="box-25">
                        {{ trans('pages.stockcount_tablet.stock.unit') }}
                    </div>
                    <div class="box-25">
                        <ui5-select
                            v-if="units"
                            :disabled="!inputEnabled"
                            @change="
                                profile.unitName =
                                    $event.detail.selectedOption.value;
                                updateTablet();
                            "
                        >
                            <ui5-option
                                v-for="unit in units"
                                :key="unit.name"
                                :selected="
                                    profile && profile.unitName == unit.name
                                "
                                :value="unit.name"
                            >
                                {{ unit.name }}
                            </ui5-option>
                        </ui5-select>
                    </div>

                    <div class="box-25 pad">
                        {{
                            trans(
                                'pages.stockcount_tablet.stock.package_per_unit'
                            )
                        }}
                    </div>
                    <div class="box-25">
                        <ui5-input
                            type="Text"
                            :value="profile ? profile.packagePerUnit : ''"
                            @input="
                                profile.packagePerUnit = $event.target.value
                            "
                            :disabled="!inputEnabled"
                        />
                    </div>
                </div>

                <div class="box-row">
                    <div class="box-25">
                        {{ trans('pages.stockcount_tablet.stock.min_stock') }}
                    </div>
                    <div class="box-25">
                        <text-input
                            type="number"
                            :value="profile ? profile.minStock : ''"
                            @input="profile.minStock = $event"
                            :disabled="!inputEnabled"
                            @change="updateTablet"
                        />
                    </div>

                    <div class="box-25 pad">
                        {{ trans('pages.stockcount_tablet.stock.max_stock') }}
                    </div>
                    <div class="box-25">
                        <text-input
                            type="number"
                            :value="profile ? profile.maxStock : ''"
                            @input="profile.maxStock = $event"
                            :disabled="!inputEnabled"
                            @change="updateTablet"
                        />
                    </div>
                </div>

                <div class="box-row">
                    <div class="box-25">
                        {{
                            trans(
                                'pages.stockcount_tablet.stock.stock_location'
                            )
                        }}
                    </div>
                    <div class="box-25">
                        <ui5-select
                            v-if="profile && stockLocations"
                            @change="
                                profile.stockLocationId =
                                    $event.detail.selectedOption.value;
                                updateTablet();
                            "
                        >
                            <ui5-option
                                :value="null"
                                :selected="profile.stockLocationId == null"
                            >
                                ---
                            </ui5-option>
                            <ui5-option
                                v-for="location in stockLocations"
                                :value="location.ID"
                                :selected="
                                    location.ID == profile.stockLocationId
                                "
                                :key="'stockLocation.' + location.ID"
                            >
                                {{ location.label }}
                            </ui5-option>
                        </ui5-select>
                    </div>

                    <div class="box-25 pad">
                        {{ trans('pages.stockcount_tablet.stock.bin') }}
                    </div>
                    <div class="box-25">
                        <ui5-input
                            type="Text"
                            :value="profile ? profile.binLocation : ''"
                            @input="profile.binLocation = $event.target.value"
                            :disabled="!inputEnabled"
                            @change="updateTablet"
                        />
                    </div>
                </div>

                <div class="box-row">
                    <div class="box-25">
                        {{ trans('pages.stockcount_tablet.stock.keep_stock') }}
                    </div>
                    <div class="box-25">
                        <ui5-select
                            @change="
                                profile.keepStock =
                                    $event.detail.selectedOption.value;
                                updateTablet();
                            "
                            :disabled="!inputEnabled"
                        >
                            <ui5-option
                                value="1"
                                :selected="profile && profile.keepStock == 1"
                            >
                                {{ trans('pages.stockcount_tablet.stock.yes') }}
                            </ui5-option>
                            <ui5-option
                                value="0"
                                :selected="profile && profile.keepStock == 0"
                            >
                                {{ trans('pages.stockcount_tablet.stock.no') }}
                            </ui5-option>
                        </ui5-select>
                    </div>
                </div>
            </div>

            <div class="box">
                <div class="box-title">
                    {{ trans('pages.stockcount_tablet.calculate.title') }}
                </div>

                <div class="box-row">
                    <div class="box-33">
                        {{
                            trans(
                                'pages.stockcount_tablet.calculate.weighted_weight'
                            )
                        }}
                    </div>
                    <div class="box-33">
                        <text-input
                            type="number"
                            v-model="calculateWeighted"
                            :disabled="!inputEnabled"
                        />
                    </div>

                    <div class="box-34 pad">
                        <ui5-button
                            @click="calculate"
                            :disabled="!inputEnabled || calculateDisabled"
                        >
                            {{
                                trans('pages.stockcount_tablet.calculate.title')
                            }}
                        </ui5-button>
                    </div>
                </div>

                <div class="box-row">
                    <div class="box-33">
                        {{
                            trans(
                                'pages.stockcount_tablet.calculate.package_weight'
                            )
                        }}
                    </div>
                    <div class="box-33">
                        <text-input
                            type="number"
                            :value="profile ? profile.weightBox : ''"
                            @input="profile.weightBox = $event"
                            :disabled="!inputEnabled"
                        />
                    </div>
                </div>

                <div class="box-row">
                    <div class="box-33">
                        {{
                            trans(
                                'pages.stockcount_tablet.calculate.count_per_kg'
                            )
                        }}
                    </div>
                    <div class="box-33">
                        <text-input
                            type="number"
                            :value="profile ? profile.countPerKg : ''"
                            @input="profile.countPerKg = $event"
                            :disabled="!inputEnabled"
                        />
                    </div>
                </div>

                <div class="box-row">
                    <div class="box-33">
                        {{
                            trans(
                                'pages.stockcount_tablet.calculate.weight_per_unit'
                            )
                        }}
                    </div>
                    <div class="box-33">
                        <text-input
                            type="number"
                            @change="calculateWeight"
                            :value="profile ? profile.weight : ''"
                            @input="profile.weight = $event"
                            :disabled="!inputEnabled"
                        />
                    </div>

                    <div class="box-34 pad">
                        <ui5-button @click="$router.push('/stockcount')">
                            {{
                                trans(
                                    'pages.stockcount_tablet.calculate.back_to_overview'
                                )
                            }}
                        </ui5-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import profileApi from '../api/profile';
import exportApi from '../api/export';
import stockLocationApi from '../api/stockLocation';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import { articleMocker, stockLocationMocker } from '../shared/qrMockers';
import TextInput from '../components/TextInput';

const PROFILE_SCAN_KEY = 'stockcounttablet_profile';
const LOCATION_SCAN_KEY = 'stockcounttablet_location';

export default {
    components: { TextInput },
    data() {
        return {
            calculateWeighted: '',
            profileCode: '',
            profile: null,
            inputEnabled: false,
            units: null,
            stockLocations: null,
        };
    },
    computed: {
        selectedPrinterPostParameter() {
            return this.$store.getters[
                'printers/getSelectedPrinterPostParameter'
            ]();
        },
        calculateDisabled() {
            if (!this.profile) {
                return true;
            }
            const weighted = parseFloat(this.calculateWeighted);
            const boxWeight = parseFloat(this.profile.weightBox);
            const weightPerUnit = parseFloat(this.profile.weight);
            if (isNaN(weighted) || isNaN(boxWeight) || isNaN(weightPerUnit)) {
                return true;
            }
            return false;
        },
    },
    mounted() {
        profileApi.fetchUnits().then((response) => {
            this.units = response.data.data;
        });

        this.$bus.$on('qr_scanner.on_scan', (key, value) => {
            switch (key) {
                case PROFILE_SCAN_KEY:
                    return this.onScanProfile(value);
                case LOCATION_SCAN_KEY:
                    return this.onScanLocation(value);
            }
        });

        this.load();
    },
    methods: {
        scanProfile() {
            this.$bus.$emit('qr_scanner.start', PROFILE_SCAN_KEY, {
                singleScan: true,
                defaultCamera: 'front',
                mocker: articleMocker,
            });
        },
        scanLocation() {
            this.$bus.$emit('qr_scanner.start', LOCATION_SCAN_KEY, {
                singleScan: true,
                defaultCamera: 'front',
                mocker: stockLocationMocker,
            });
        },
        onScanProfile(value) {
            let decoded = null;
            try {
                decoded = JSON.parse(value);
            } catch (error) {}

            if (decoded && decoded.context === 'article') {
                this.profileCode = decoded.articleCode;
                this.showProfileTablet();
            } else {
                showErrorMessage(
                    'Deze QR-code dient niet om artikelen te identificeren',
                    null,
                    1500
                );
            }
        },
        onScanLocation(value) {
            let decoded = null;
            try {
                decoded = JSON.parse(value);
            } catch (error) {}

            if (decoded && decoded.context === 'stockLocation') {
                this.loadStockLocations().then(() => {
                    const location = this.stockLocations.find(
                        (x) => x.ID == decoded.stocklocationId
                    );
                    if (!location) {
                        showErrorMessage('Ongeldige stocklocatie');
                    } else {
                        this.profile.stockLocationId = location.ID;
                        this.updateTablet().then(() => {
                            showInfoMessage(
                                'Het artikel werd toegewezen aan locatie ' +
                                    location.label
                            );
                        });
                    }
                });
            } else {
                showErrorMessage(
                    'Deze QR-code dient niet om stocklocaties te identificeren',
                    null,
                    1500
                );
            }
        },
        calculate() {
            const weighted = parseFloat(this.calculateWeighted);
            const boxWeight = parseFloat(this.profile.weightBox);
            const weightPerUnit = parseFloat(this.profile.weight);
            const currentStockCount = (weighted - boxWeight) / weightPerUnit;
            this.profile.currentstockcount = parseFloat(
                currentStockCount.toFixed(4)
            );
            this.updateTablet();
        },
        printKanban() {
            KeyHelper.handlePrintOrExport(
                () => exportApi
                    .printProfileKanbanLabel(this.profile.profileId, this.selectedPrinterPostParameter)
                    .then(() => { showInfoMessage('De etiketten zijn afgedrukt.'); }),
                Config.url + '/export/exportProfileKanbanLabel/?profileId=' + this.profile.profileId
            );
        },
        printLabel() {
            KeyHelper.handlePrintOrExport(
                () => exportApi
                    .printProfileLabel(this.profile.profileId, this.selectedPrinterPostParameter)
                    .then(() => { showInfoMessage('De etiketten zijn afgedrukt.'); }),
                Config.url + '/export/exportProfileLabel/?profileId=' + this.profile.profileId
            );
        },
        getLatestCount() {
            const date = new Date(this.profile.latestCount * 1000);
            return (
                date.getDate() +
                '-' +
                date.getMonth() +
                1 +
                '-' +
                date.getFullYear()
            );
        },
        calculateWeight(event) {
            const countPerKg = 1000 / parseFloat(this.profile.weight);
            this.profile.countPerKg = parseFloat(countPerKg.toFixed(4));
        },
        load() {
            this.clearProfileTabletInput();
            this.inputEnabled = false;
        },
        clearProfileTabletInput() {
            this.profile = null;
            this.profileCode = '';
            this.calculateWeighted = '';
        },
        updateTablet() {
            const profile = this.profile;

            const payload = {
                profileId: profile.profileId,
                currentstockcount: profile.currentstockcount,
                unitRef: profile.unitName,
                packagePerUnit: profile.packagePerUnit,
                minStock: profile.minStock,
                maxStock: profile.maxStock,
                location: profile.location,
                binLocation: profile.binLocation || '',
                keepStock: profile.keepStock,
                weightBox: profile.weightBox,
                countPerKg: profile.countPerKg,
                weight: profile.weight,
                stockLocationId: profile.stockLocationId || null,
            };

            return profileApi
                .updateTablet(payload)
                .then(this.showProfileTablet);
        },
        showProfileTablet() {
            this.inputEnabled = false;

            Promise.all([
                this.loadStockLocations(),
                profileApi
                    .fetchByCode(this.profileCode)
                    .then((response) => {
                        this.profile = response.data.data;
                    })
                    .catch(() => {
                        showErrorMessage('Onbekende artikelcode');
                        this.clearProfileTabletInput();
                    }),
            ]).then(() => {
                this.inputEnabled = true;
            });
        },
        loadStockLocations() {
            return stockLocationApi.fetchAll().then((response) => {
                this.stockLocations = response.data.data;
            });
        },
    },
};
</script>
